import * as React from "react";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import { useQuery } from "../hooks/useQuery";

const DemaisArquivosItem = ({ item, onPressDelete, atualizarLista, isPagamentoDireto }) => {
  const theme = useTheme();
  const { atualizarArquivoDaNotaFiscal, atualizarArquivoPagamentoDireto } = useQuery();
  
  React.useEffect(() => {
    if (item && item.descricao) {
      setDescription(item.descricao);
    }
  }, [item])

  const [description, setDescription] = React.useState(
    item.descricao ? item.descricao : ""
  );
  const [isLoading, setIsLoading] = React.useState(false);

  const onChangeDescricao = (e) => {
    setDescription(e.target.value);
  };

  const onBlurDescricao = async () => {
    try {
      setIsLoading(true);
      if (isPagamentoDireto) {
        await atualizarArquivoPagamentoDireto(item.id, {
          descricao: description,
        });
      }else{
        await atualizarArquivoDaNotaFiscal(item.id, {
          descricao: description,
        });
      }
    
      atualizarLista();
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const styleBorder = description
    ? `1px solid ${theme.palette.primary.light}`
    : `1px solid ${theme.palette.error.main}`;

  return (
    <div
      style={{
        border: styleBorder,
        borderRadius: "0.2rem",
        marginTop: "1rem",
      }}
    >
      <Grid container>
        <Grid item sm={6}>
          <TextField
            id="standard-multiline-static"
            label="Digite aqui uma descrição"
            multiline
            style={{
              width: "98%",
              border: "none",
              paddingLeft: "0.4rem",
              borderRadius: "0.2rem",
              outline: 0,
            }}
            rows={1}
            value={description}
            variant="standard"
            onBlur={() => onBlurDescricao(item)}
            onChange={onChangeDescricao}
          />
        </Grid>
        <Grid item sm={6}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div
              style={{
                padding: "1rem",
                borderLeft: styleBorder,
              }}
            >
              <a href={item.link} target="_blank">
                {item.nome}
              </a>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "0.8rem",
                borderLeft: styleBorder,
              }}
            >
              <div
                style={{ marginTop: "2px", cursor: "pointer" }}
                onClick={() => {
                  if (item.can_delete) {
                    onPressDelete(item);
                  }
                }}
              >
                {isLoading ? (
                  <CircularProgress size={20} />
                ) : item.can_delete ? (
                  <DeleteOutlinedIcon
                    sx={{
                      color: theme.palette.error.main,
                    }}
                    style={{ margin: 0, padding: 0 }}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default DemaisArquivosItem;
